import createSnackbar from 'modules/App/factories/createSnackbar'
import deleteFromBasket from '../actions/deleteFromBasket'
import { unset } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import { parallel, sequence } from 'cerebral'

export default [
  parallel('deleteOrderItem', [
    createSnackbar({
      key: 'bms.orderBasket.deletedOrderItem',
      params: { count: 1 }
    }),
    sequence([
      deleteFromBasket,
      unset(state`basket.basketItems.${props`orderItemId`}`)
    ])
  ])
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/deleteFromBasket.js